import { GoogleAuthProvider, OAuthProvider, FacebookAuthProvider, signInWithPopup } from 'firebase/auth';
import { firebaseAuth } from './config';

// Each of these signs the user into Firebase via a popup, then returns
// Firebase's own ID token -- the backend verifies that one token type for
// all three providers (see POST /api/auth/firebase), rather than us having
// to integrate Google's and Apple's separate SDKs/verification directly.
async function signInAndGetIdToken(provider: GoogleAuthProvider | OAuthProvider | FacebookAuthProvider): Promise<string> {
    const result = await signInWithPopup(firebaseAuth, provider);
    return result.user.getIdToken();
}

export const signInWithGoogle = () => signInAndGetIdToken(new GoogleAuthProvider());

export const signInWithApple = () => signInAndGetIdToken(new OAuthProvider('apple.com'));

export const signInWithFacebook = () => signInAndGetIdToken(new FacebookAuthProvider());
